// src/app/app.config.ts
import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID, inject } from '@angular/core';
import { provideRouter, withViewTransitions, withEnabledBlockingInitialNavigation, withInMemoryScrolling, withRouterConfig, Router } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/auth/auth-interceptor';
import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { environment } from '../environments/environment';


function apiImageLoader({ src, width, loaderParams }: ImageLoaderConfig): string {
  const parse = () => {
    try { return new URL(src, 'http://x'); } catch { return null; }
  };
  const u = parse();
  const file = u ? (u.pathname.split('/').pop() || src) : src;

  const base = environment.production
    ? `${environment.apiUrl}/images/${file}`
    : `/api/images/${file}`;

  const qs = new URLSearchParams(u?.search || '');
  if (width) qs.set('width', String(Math.round(width)));
  if (!qs.has('format')) qs.set('format', String((loaderParams as any)?.format ?? 'auto'));
  if ((loaderParams as any)?.quality) qs.set('quality', String((loaderParams as any).quality));

  return `${base}?${qs.toString()}`;
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withViewTransitions({
        skipInitialTransition: true,
        onViewTransitionCreated: ({ transition }) => {
          const router = inject(Router);
          const targetUrl = router.getCurrentNavigation()!.finalUrl!;
          const isSameWithoutFragment = router.isActive(
            targetUrl,
            { paths: 'exact', fragment: 'ignored', queryParams: 'ignored', matrixParams: 'exact' }
          );
          if (isSameWithoutFragment) {
            transition.skipTransition();
          }
        }
      }),
      withRouterConfig({ onSameUrlNavigation: 'ignore', paramsInheritanceStrategy: 'always' })
    ),

    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideClientHydration(withEventReplay()),

    { provide: IMAGE_LOADER, useValue: apiImageLoader },
  ]
};